import feathersClient from "../../feathers-client";

const defaultRejectReasonsConfigurationPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultRejectReasonsConfigurationPaginationFilter = {
	$skip:defaultRejectReasonsConfigurationPagination.$skip,
	$limit: defaultRejectReasonsConfigurationPagination.$limit
};

export default {
	state:{
		RejectReasonsConfiguration:[],
		RejectReasonsConfigurationPagination:defaultRejectReasonsConfigurationPagination,
		RejectReasonsConfigurationPaginationFilter:defaultRejectReasonsConfigurationPaginationFilter
	},
	getters:{
		setRejectReasonsConfigurationPage:(state) => {
			const {$limit, $skip} = state.RejectReasonsConfigurationPagination;
			return $skip / $limit + 1;
		}

	},
	mutations:{
		SET_REJECT_REASONS_CONFIGURATION:(state,data) => {state.RejectReasonsConfiguration = data;},
		SET_REJECT_REASONS_CONFIGURATION_PAGINATION:(state, data) => {state.RejectReasonsConfigurationPagination = {...state.RejectReasonsConfigurationPagination, ...data};},
		SET_REJECT_REASONS_CONFIGURATION_PAGINATION_FILTER:(state,data) => {state.RejectReasonsConfigurationPaginationFilter  = {...state.RejectReasonsConfigurationPaginationFilter, ...data};}

	},
	actions:{
		setRejectReasonsConfigurationListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.RejectReasonsConfigurationPagination.$limit;
			commit('SET_REJECT_REASONS_CONFIGURATION_PAGINATION', { $skip });
			commit('SET_REJECT_REASONS_CONFIGURATION_PAGINATION_FILTER', { $skip });
		},

		getRejectReasonsConfiguration: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/reject-reasons-configuration').find({
				query:{
					// $role: rootGetters.currentUserRole,
					...filter
				}
			});
			commit('SET_REJECT_REASONS_CONFIGURATION',results.data);
			commit('SET_REJECT_REASONS_CONFIGURATION_PAGINATION', {total :results.total})
			return results.data;
		},
		createRejectReasonsConfiguration: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/reject-reasons-configuration').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateRejectReasonsConfiguration: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/reject-reasons-configuration').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		deleteRejectReasonsConfiguration: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/reject-reasons-configuration').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getRejectReasonsConfigurationById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/reject-reasons-configuration').get(id,{
				query:{
					// $role: rootGetters.currentUserRole,
				}
			});

			return results
		},
		getAllRejectReasonsConfigurationForTrust: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/reject-reasons-configuration').find({
				query:{
					$role:rootGetters.currentUserRole,

				}
			});
			return results;
		},
		getAllRejectReasonsConfiguration: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/reject-reasons-configuration').find({
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results.data;
		}

	}
}
